/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_EyebrowInputs */

const tr_mesafeli_eyebrow = /** @type {(inputs: Mesafeli_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MESAFELİ HİZMET SÖZLEŞMESİ`)
};

const en_mesafeli_eyebrow = /** @type {(inputs: Mesafeli_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DISTANCE SERVICE AGREEMENT`)
};

const de_mesafeli_eyebrow = /** @type {(inputs: Mesafeli_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FERNABSATZ-DIENSTLEISTUNGSVERTRAG`)
};

const ru_mesafeli_eyebrow = /** @type {(inputs: Mesafeli_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДОГОВОР ДИСТАНЦИОННОГО ОКАЗАНИЯ УСЛУГ`)
};

/**
* | output |
* | --- |
* | "DISTANCE SERVICE AGREEMENT" |
*
* @param {Mesafeli_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_eyebrow = /** @type {((inputs?: Mesafeli_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_eyebrow(inputs)
	if (locale === "de") return de_mesafeli_eyebrow(inputs)
	if (locale === "ru") return ru_mesafeli_eyebrow(inputs)
	return tr_mesafeli_eyebrow(inputs)
});